import { defaultPeriscopeState } from '../read/state';
import { PeriscopeState, RemovePeriscopeSync } from '@sonar-software/sonar-ts-types';

export function removePeriscope(removePeriscopeSync: RemovePeriscopeSync, state: PeriscopeState): PeriscopeState {
	const { periscopeIndex } = removePeriscopeSync;

	return {
		...defaultPeriscopeState,
		cards: [ ...state.cards.slice(0, periscopeIndex) ]
	};
}
